export default __webpack_public_path__ + "assets/images/0a6a95450bfcfde2bc3a84618a331a0e.png";